import { styled } from 'styles';

export const StyledIcon = styled.div`
  align-items: center;
  display: inline-flex;
  height: 1em;
  justify-content: center;
  width: 1em;

  svg {
    height: 1em;
    width: 1em;
  }
`;

StyledIcon.displayName = 'Icon.Styled';
